import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/BrandGeometry";
import { COMPANY } from "@/lib/content";

export default function Introduction() {
  return (
    <section id="for-charities" className="border-b border-line bg-white">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:px-10 sm:py-32 lg:px-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <Eyebrow>For Charities</Eyebrow>
              <h2 className="mt-6 font-display text-3xl font-medium leading-tight tracking-tight text-navy sm:text-4xl">
                A fundraising partner built on trust
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-8 lg:pt-1">
            <Reveal delay={0.1}>
              <p className="font-display text-2xl font-medium leading-snug text-navy sm:text-[1.75rem]">
                Amanah Promotions is a fundraising and promotions agency representing charities with
                integrity, accountability and transparency.
              </p>
              <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-body sm:text-lg">
                We support organisations seeking professional donor acquisition throughout{" "}
                {COMPANY.area}.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
